<template>
  <v-container :class="containerClass" fluid>
    <teacher-form mode="edit" :teacher="teacher.data" @cancel="onCancel">
      <template #header>
        <div class="d-flex align-center">
          <v-btn
            icon
            color="primary"
            class="mr-2"
            :href="$route('teachers.index')"
          >
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
          <h2>Edit {{ teacher.data.name }}</h2>
        </div>
      </template>
    </teacher-form>
  </v-container>
</template>

<script>
import LayoutDashboard from '@layouts/Dashboard'
import TeacherForm from '@components/Teacher/Form'
export default {
  components: {
    TeacherForm,
  },
  layout: LayoutDashboard,
  props: {
    teacher: {
      type: Object,
      required: true,
    },
  },
  methods: {
    onCancel() {
      window.location.href = this.$route('teachers.index')
    },
  },
}
</script>
